import { EmailTypes } from '.';

const refreshEmailSuccess = (result) => ({
    type: EmailTypes.REFRESH_EMAIL_SUCCESS,
    payload: { ...result },
});

const refreshEmailFailure = (error) => ({
    type: EmailTypes.REFRESH_EMAIL_FAIL,
    payload: { error },
});

const loginEmailSuccess = (result) => ({
    type: EmailTypes.LOGIN_EMAIL_SUCCESS,
    payload: { ...result },
});

const loginEmailFailure = (error) => ({
    type: EmailTypes.LOGIN_EMAIL_FAIL,
    payload: { error },
});

export {
    refreshEmailSuccess, refreshEmailFailure, loginEmailSuccess, loginEmailFailure,
};
